import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

export const APP_TITLE = 'Bebidas · Nigal';

/** Compone `<sección> · Bebidas · Nigal`, o solo el nombre de la app si la ruta no declara título. */
@Injectable({ providedIn: 'root' })
export class BebidasTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const seccion = this.buildTitle(snapshot);
    this.title.setTitle(seccion ? `${seccion} · ${APP_TITLE}` : APP_TITLE);
  }
}
